module.exports = __webpack_public_path__ + "static/beaubble-875a28aefd0b5e682481853357881e2f.jpg";